import { PageHeaderButton } from '@vtex/admin-ui'
import { useNavigation } from '@vtex/raccoon-next'
import { FormattedMessage } from 'react-intl'

export function ArchivedPromotionHeaderButtons() {
  const { navigate } = useNavigation()

  function handleUnarchive() {
    throw new Error('Not implemented')
  }

  return (
    <>
      <PageHeaderButton
        variant="secondary"
        onClick={() => navigate('/archived')}
      >
        <FormattedMessage id="admin/promotions.utils.cancel" />
      </PageHeaderButton>
      <PageHeaderButton onClick={handleUnarchive}>
        <FormattedMessage id="admin/promotions.list.actions.unarchive" />
      </PageHeaderButton>
    </>
  )
}
